import React from 'react'
import PageNavigation from '../components/page_navigation'
import {useQuery} from "./use_query";

export default function usePagination(): [number, React.ReactNode, React.Dispatch<React.SetStateAction<number>>] {
  const page = useQuery('page') || '1';
  let pageInt = 1;
  try {
    pageInt = parseInt(page);
  } catch (err) {}

  const [totalPages, setTotalPages] = React.useState(1);
  // console.log('usePagination', page, totalPages)
  const paginator = <PageNavigation
    page={pageInt}
    totalPages={totalPages}
  />;

  return [pageInt, paginator, setTotalPages];
}